import { render, staticRenderFns } from "./ManageDB.vue?vue&type=template&id=7c05a670&scoped=true&lang=pug&"
import script from "./ManageDB.vue?vue&type=script&lang=js&"
export * from "./ManageDB.vue?vue&type=script&lang=js&"
import style0 from "./ManageDB.vue?vue&type=style&index=0&id=7c05a670&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c05a670",
  null
  
)

export default component.exports